import { WaterCharacteristicsDefinitions } from "@src/core/engine/technicalParameters/waterCharacteristics/waterCharacteristicsRepository";
import {
  isZodValidationResult,
  useParseZodValidationResult,
} from "@src/core/engine/validationResults/useParseZodValidationResult";
import { useTranslation } from "react-i18next";
import { useWaterCharacteristicsForm } from "../hooks/useWaterCharacteristicsForm";
import styles from "./ExistingAdditivesForm.module.css";

type ExistingAdditivesFormProps = {
  definitions: WaterCharacteristicsDefinitions;
  form: ReturnType<typeof useWaterCharacteristicsForm>["form"];
};

export function WaterInformationForm({
  definitions,
  form,
}: ExistingAdditivesFormProps) {
  const { t } = useTranslation("settings");
  const parseZodValidationResult = useParseZodValidationResult({
    fieldsT: {
      prefix: "technicalPreferences.waterCharacteristics",
      t,
    },
  });

  const parseErrors = (errors: unknown[]) =>
    errors.map((error) =>
      typeof error === "string"
        ? isZodValidationResult(error)
          ? parseZodValidationResult(error)
          : t(error)
        : undefined,
    );

  return (
    <>
      <fieldset className={styles.ExistingAdditivesForm}>
        <form.AppField name="density">
          {(field) => (
            <field.NumberField
              definition={definitions.density}
              errors={parseErrors(field.state.meta.errors)}
              label={t(
                "technicalPreferences.waterCharacteristics.fields.density.label",
              )}
              placeholder={t(
                "technicalPreferences.waterCharacteristics.fields.density.placeholder",
              )}
            />
          )}
        </form.AppField>

        <form.AppField name="freezingPoint">
          {(field) => (
            <field.NumberField
              definition={definitions.freezingPoint}
              errors={parseErrors(field.state.meta.errors)}
              label={t(
                "technicalPreferences.waterCharacteristics.fields.freezingPoint.label",
              )}
              placeholder={t(
                "technicalPreferences.waterCharacteristics.fields.freezingPoint.placeholder",
              )}
            />
          )}
        </form.AppField>

        <form.AppField name="kinematicViscosity">
          {(field) => (
            <field.NumberField
              definition={definitions.kinematicViscosity}
              errors={parseErrors(field.state.meta.errors)}
              label={t(
                "technicalPreferences.waterCharacteristics.fields.kinematicViscosity.label",
              )}
              placeholder={t(
                "technicalPreferences.waterCharacteristics.fields.kinematicViscosity.placeholder",
              )}
            />
          )}
        </form.AppField>

        <form.AppField name="specificHeat">
          {(field) => (
            <field.NumberField
              definition={definitions.specificHeat}
              errors={parseErrors(field.state.meta.errors)}
              label={t(
                "technicalPreferences.waterCharacteristics.fields.specificHeat.label",
              )}
              placeholder={t(
                "technicalPreferences.waterCharacteristics.fields.specificHeat.placeholder",
              )}
            />
          )}
        </form.AppField>
      </fieldset>
    </>
  );
}
